module.exports = __webpack_public_path__ + "static/media/add_ic.7f2b1f7b.svg";